import styled from "styled-components";

import { Spacing, Text } from "@otta/design";
import {
  pxToRem,
  borderRadius,
  modularScale,
  palette,
} from "@otta/design-tokens";

const Wrapper = styled.div<{ numberOfBars: number }>`
  width: 100%;

  span {
    display: inline-block;
    border-radius: ${pxToRem(borderRadius)};
    width: ${({ numberOfBars }) => `calc(${100 / numberOfBars}% - 4px)`};
    background-color: ${palette.grayscale.shade400};
    height: ${modularScale()};
    margin: 0 4px 0 0;
  }

  span.active {
    background-color: ${palette.extended.green.shade600};
  }
`;

export function ProgressBar({
  numberOfBars,
  numberCompleted,
}: {
  numberOfBars: number;
  numberCompleted: number;
}): React.ReactElement {
  const numRemaining = numberOfBars - numberCompleted;
  return (
    <Spacing>
      <Text bold>
        {numRemaining > 0
          ? `${numRemaining} section${numRemaining === 1 ? "" : "s"} left`
          : `All done!`}
      </Text>
      <Wrapper numberOfBars={numberOfBars}>
        {[...Array(numberOfBars)].map((_, index) => (
          <span
            key={index}
            className={index < numberCompleted ? "active" : undefined}
          />
        ))}
      </Wrapper>
    </Spacing>
  );
}
